const SI = {
  ibanLength: 19,
};
export { SI };
